_ = require 'underscore'
$ = require 'jquery'
Dialog = require 'views/lib/dialog'
Keys = require 'data/keys'
PluginBoardBarView = require 'views/plugin/plugin-board-bar-view'
PopOver = require 'views/lib/pop-over'
SidebarState = require 'view-models/sidebar-state'

DEFAULT_HEIGHT = 200
# what percentage of board view (vertically) a board bar may consume
MAX_PERCENTAGE = 0.6
# space dedicated to Trello Chrome around the iframe
CHROME_SPACE = 44
# how much vertical space to reserve for board header and a glimpse of your lists
MINIMUM_REMAINDER_HEIGHT = 180

module.exports = PluginBoardBar = new class

  @boardBarView = null
  @desiredHeight = DEFAULT_HEIGHT

  _computeMaxHeight: ->
    boardHeight = $('.board-main-content').height()
    maxHeight = (MAX_PERCENTAGE * boardHeight) - CHROME_SPACE

    if (1 - MAX_PERCENTAGE) * boardHeight < MINIMUM_REMAINDER_HEIGHT
      maxHeight = boardHeight - CHROME_SPACE - MINIMUM_REMAINDER_HEIGHT
      if maxHeight < 0 then maxHeight = 0

    return maxHeight

  isOpen: -> @boardBarView?

  restrictHeight: (userOverride) ->
    $boardBarIframe = $('.plugin-board-bar iframe')
    if !$boardBarIframe.length
      return

    if @desiredHeight < 0
      @desiredHeight = 0

    maxHeight = @_computeMaxHeight()
    actualHeight = Math.min(@desiredHeight, maxHeight)

    # when restricting height as a result of a user resize we treat desired
    # height as the actual height to prevent oversetting the field making it
    # hard / awkward to shrink
    if userOverride
      @desiredHeight = actualHeight

    $boardBarIframe.height("#{ actualHeight }px")

  open: (args) ->
    { model, content } = args

    @close()

    @boardBarView = new PluginBoardBarView({
      model,
      content,
      fxClose: @close.bind(@),
      fxResize: @incrementDesiredHeight.bind(@)
    })
    @desiredHeight = content.height || DEFAULT_HEIGHT
    $('.board-main-content').append(@boardBarView.render().el)

    @restrictHeight()
    $(window).on 'resize.plugin-board-bar', _.throttle((=> @restrictHeight()), 50)

    return

  close: ->
    if @isOpen()
      $(window).off('resize.plugin-board-bar')
      @boardBarView.close()
      @boardBarView = null
      @desiredHeight = DEFAULT_HEIGHT
    return

  setDesiredHeight: (height) ->
    @desiredHeight = height
    @restrictHeight()

  incrementDesiredHeight: (delta) ->
    @desiredHeight += delta
    @restrictHeight(true)



// WEBPACK FOOTER //
// ./app/scripts/views/lib/plugin-board-bar.coffee